import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnDestroy,
  AfterViewInit,
  inject,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { switchMap } from 'rxjs/operators';
import {
  DocumentApiService,
  OurTeamApiService,
  OurTeam,
} from '@icullen/api/document';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DocUtilsService } from './utils/doc-utils.service';
import { AnalyticsService, PostHogService, RouteTrackingService, TourService } from '@icullen/api/shared';
import { CategoryEventService } from '@icullen/utils';
import { AuthorDetail } from './document/document.model';
import { RelatedDocument } from './related-posts/related-doc/related-doc.model';
import { Subscription } from 'rxjs';

import { User, AuthService } from '@icullen/api/shared';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'icullen-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DocumentViewerComponent implements OnInit, OnDestroy {
  docData: any;
  defaultAuthorImagePath = 'assets/images/author.jpg';
  defaultContactEmail = 'helpdesk@cullen-international.com';
  authorDetail: AuthorDetail;
  similarDocs: RelatedDocument[] = [];
  currentUser: User;
  private sub: Subscription;
  private tourService = inject(TourService);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private documentService: DocumentApiService,
    private deviceService: DeviceDetectorService,
    private analyticsService: AnalyticsService,
    private categoryEventService: CategoryEventService,
    private ourTeamService: OurTeamApiService,
    private docutils: DocUtilsService,
    private ref: ChangeDetectorRef,
    private authService: AuthService,
    private titleService: Title,
    private postHogService: PostHogService
  ) {
    this.currentUser = this.authService.getCurrentUser();
  }

  // ngAfterViewInit(): void {
  //   const topicTourSeen = localStorage.getItem('topicTourSeen');
  //   if (!topicTourSeen && this.currentUser.UserType === 'CULLEN_USER') {
  //     this.tourService.startTopicsTour();
  //     localStorage.setItem('topicTourSeen', 'true');
  //   }
  // }

  ngOnInit() {
    

    const routeParams$ = combineLatest(
      this.route.params,
      this.route.queryParams
    );

    const data$ = routeParams$.pipe(
      map((combined) => ({
        uniqueNumber: combined[0].uniqueNumber,
        query: combined[1].version,
      })),
      switchMap((results) =>
        this.documentService.getDocumentByUniqueNumber(
          results.uniqueNumber,
          results.query
        )
      )
    );

    this.sub = data$.subscribe((data) => {
      //redirect to genesis if not supported by site viewer & not in demo mode
      if (
        !data.demo &&
        this.docutils.isDocNotSupportedByViewer(data.uniqueNumber)
      ) {
        const version: string = this.route.snapshot.queryParams.version;
        window.location.href = this.docutils.getGenesisRedirectUrl(
          data.uniqueNumber,
          version
        );
      } else {
        this.docData = data;

        this.ourTeamService
          .getAnalystInfo(this.docData.contactEmail)
          .subscribe((ourteam: OurTeam) => {
            this.createAuthorDetail(ourteam);
            this.ref.detectChanges();
          });

        this.postHogService.trackContentAccessed(this.docData.uniqueNumber);
        this.postHogService.setNextContentAccess({
          uniqueNumber: this.docData.uniqueNumber})

        if (!this.docData.publication) {
          this.documentService
            .getSimilarDocuments(this.docData.uniqueNumber)
            .subscribe((similarDocumentsData) => {
              this.similarDocs = similarDocumentsData.similarDocs;
              this.ref.detectChanges();
            });
        }else {
          this.postHogService.setNextContentAccess({
            traffic_source: 'publication',
          });
        }

        //analytics data
        this.analyticsService.pushDocumentViewData(
          this.docData,
          this.router.url
        );

        

        this.categoryEventService.emitCategoryEvent(this.docData.serviceName);
        this.ref.detectChanges();
      }
    });
  }

  createAuthorDetail(ourteam: OurTeam) {
    let contactEmail = this.defaultContactEmail;
    let docAuthorImagePath = this.defaultAuthorImagePath;
    if (ourteam.analyst && ourteam.analyst.length > 0) {
      docAuthorImagePath = ourteam.analyst[0].image?.renditions?.thumbnail.link;
      if (ourteam.analyst[0].showInOurTeamPage === 'true') {
        contactEmail = this.docData.contactEmail;
      }
    }
    this.authorDetail = {
      contactEmail: contactEmail,
      docAuthorImagePath: docAuthorImagePath,
    };
    //console.log(this.authorDetail);
  }

  isMobile() {
    const isMobile = this.deviceService.isMobile();
    // console.log(isMobile);
    // console.log(this.deviceService.getDeviceInfo());
    return this.deviceService.isMobile();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
    this.titleService.setTitle('Cullen International');
  }
}
